var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFindUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 49.0002L73 73.0002M29 57.0002C13.536 57.0002 1 44.4642 1 29.0002C1 13.5363 13.536 1.00024 29 1.00024C44.464 1.00024 57 13.5363 57 29.0002C57 44.4642 44.464 57.0002 29 57.0002Z",
    stroke: "#2F1612",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 42C41 35.5567 35.6274 30.3333 29 30.3333C22.3726 30.3333 17 35.5567 17 42M29 25.3333C25.2129 25.3333 22.1429 22.3486 22.1429 18.6667C22.1429 14.9848 25.2129 12 29 12C32.7871 12 35.8571 14.9848 35.8571 18.6667C35.8571 22.3486 32.7871 25.3333 29 25.3333Z",
    stroke: "#2F1612",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindUser);
export default __webpack_public_path__ + "static/media/find-user.3615368da93d91fe899bd915e522b192.svg";
export { ForwardRef as ReactComponent };